import Title from "./Typography";

export default Title;
